import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  signal,
  untracked,
} from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import QRCode from 'qrcode';

/**
 * QR code de retrait — le producteur scanne ce code pour valider automatiquement le retrait.
 */
@Component({
  selector: 'ct-pickup-qr',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <figure class="pickup-qr">
      @if (svg(); as markup) {
        <div class="qr" [innerHTML]="markup"></div>
      } @else {
        <p class="ct-muted">Génération du QR…</p>
      }
      <figcaption class="ct-muted small">Présentez ce QR au producteur lors du retrait.</figcaption>
      <p class="token">{{ confirmToken() }}</p>
    </figure>
  `,
  styles: `
    .pickup-qr {
      margin: 0;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 0.5rem;
    }

    .qr :global(svg) {
      display: block;
      width: 160px;
      height: 160px;
      border-radius: var(--ct-radius-sm);
      background: #fff;
      padding: 0.35rem;
    }

    .token {
      margin: 0;
      font-family: monospace;
      font-size: var(--ct-size-sm);
      word-break: break-all;
    }
  `,
})
export class CtPickupQr {
  private readonly sanitizer = inject(DomSanitizer);

  readonly confirmToken = input.required<string>();

  protected readonly svg = signal<SafeHtml | undefined>(undefined);

  constructor() {
    effect(() => {
      const token = this.confirmToken();
      untracked(() => {
        void QRCode.toString(token, { type: 'svg', margin: 1, width: 160 }).then((markup) => {
          this.svg.set(this.sanitizer.bypassSecurityTrustHtml(markup));
        });
      });
    });
  }
}
